import { setUrlParam } from "../base/utils/urlParams.utils";
import { NavigatorController } from "../controllers/navigator.controller";

export const autoNavigateToCounsellingJourneyOverlay = async (
  NAVIGATOR: NavigatorController,
  applicationId: string,
) => {
  setUrlParam('applicationId', applicationId, NAVIGATOR);
}
